<template>
  <div class="container mt-5">
    <LiveToast
      title="Oops..."
      bodyMessage="Only images with dimensions 1280x720 or less are supported!"
      toastIconClass="fa fa-exclamation-circle"
      toastIconColor="red"
      ref="liveToast"
    ></LiveToast>
    <div class="row">
      <div class="col-lg-9 mx-auto">
        <!-- Upload image input-->
        <div class="input-group mb-3 px-2 py-2 rounded-pill bg-white shadow-lg">
          <input
            id="upload"
            @change="onFileSelected"
            ref="fileInput"
            type="file"
            class="form-control border-0"
            accept="image/png, image/jpeg, image/jpg"
          />
          <label id="upload-label" for="upload" class="text-muted">{{
            imageLabel
          }}</label>
          <div class="input-group-append" @click="$refs.fileInput.click()">
            <label for="" class="btn btn-light m-0 rounded-pill px-3">
              <i class="fa fa-upload mr-2 text-muted"></i
              ><small class="text-uppercase font-weight-bold text-muted"
                >Choose</small
              ></label
            >
          </div>
        </div>
        <div class="image-area mt-5">
          <img
            id="imageResult"
            :src="getPreviewImage"
            alt=""
            class="img-fluid rounded shadow-lg mx-auto d-block"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LiveToast from "@/components/LiveToast.vue";

export default {
  name: "ImageInput",
  components: {
    LiveToast,
  },
  props: {
    imgLabel: String, // Image name to display in the label tag when an image is selected
    inputType: Boolean, // true for Content Image, false for Style Image
  },
  data() {
    return {
      imageLabel: this.imgLabel,
    };
  },
  computed: {
    getPreviewImage() {
      return this.inputType
        ? this.$store.getters.getContentImage
        : this.$store.getters.getStyleImage;
    },
  },
  methods: {
    onFileSelected(event) {
      let fileDetails = event.target.files;
      let reader = new FileReader();
      var vm = this;
      var hasValidDimensions = true;

      reader.readAsDataURL(fileDetails[0]);
      reader.onload = function (e) {
        let image = new Image();

        image.src = e.target.result;
        image.onload = function () {
          if (this.width > 1280 || this.height > 1000) {
            let toastDiv = vm.$refs.liveToast.$refs.liveToastDiv;
            let toast = new bootstrap.Toast(toastDiv);
            toast.show();
            hasValidDimensions = !hasValidDimensions;
          }
        };
      };

      setTimeout(() => {
        if (!hasValidDimensions) {
          return;
        }
        this.imageLabel = fileDetails[0].name;
        let details = { inputType: this.inputType, file: fileDetails };
        this.$store.commit("onFileSelected", details);
      }, 1000);
    },
  },
};
</script>

<style scoped>
#upload {
  opacity: 0;
}

#upload-label {
  position: absolute;
  top: 50%;
  left: 1rem;
  transform: translateY(-50%);
}

.image-area {
  border: 2px dashed whitesmoke;
  padding: 1rem;
  position: relative;
}

.image-area::before {
  content: "Preview";
  color: whitesmoke;
  font-weight: bold;
  text-transform: uppercase;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 0.8rem;
  z-index: 1;
}

.image-area img {
  z-index: 2;
  position: relative;
}
</style>
